import { render, staticRenderFns } from "./AddTextBubble.vue?vue&type=template&id=028c2aa1"
import script from "./AddTextBubble.vue?vue&type=script&lang=js"
export * from "./AddTextBubble.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports